export const ToastActionTypes = {
    ADD_TOAST: '@@toast/ADD_TOAST',
    REMOVE_TOAST: '@@toast/REMOVE_TOAST',
};
